'use client';

/**
 * @deprecated This file is deprecated and will be removed in a future release.
 * New code should import directly from '@campaign-manager/feature/context/LayoutContext'.
 *
 * This file re-exports from the shared LayoutContext for backward compatibility.
 */

import type { ReactNode } from 'react';

import type { StoredLayoutContext } from '@campaign-manager/app/layout/layoutContext';
import {
  type ProjectSettings,
  LayoutContextProvider as SharedLayoutContextProvider,
  type UserInfo,
  useLayoutContext,
  useMyAccount,
} from '@campaign-manager/feature/context/LayoutContext';

/**
 * @deprecated Use SharedLayoutContextProvider from '@campaign-manager/feature/context/LayoutContext' instead.
 * Wrapper that accepts the legacy { value } prop pattern and passes
 * individual props to the shared provider.
 */
export default function LayoutContextProvider({
  children,
  value,
}: {
  children?: ReactNode;
  value?: StoredLayoutContext;
}) {
  // The server layout stores the raw project settings response and the Auth0
  // user, both structurally wider than the context's own ProjectSettings and
  // UserInfo models. Converting this file from JavaScript exposed the gap; the
  // two models are reconciled at the read sites, not here.
  return (
    <SharedLayoutContextProvider
      project={(value?.project ?? null) as ProjectSettings | null}
      user={(value?.user ?? null) as UserInfo | null}
      profile={value?.profile ?? null}
      deploymentVersion={value?.deploymentVersion ?? null}
    >
      {children}
    </SharedLayoutContextProvider>
  );
}

/**
 * @deprecated Import from '@campaign-manager/feature/context/LayoutContext' instead.
 */
export { useLayoutContext, useMyAccount };
